import { render, staticRenderFns } from "./CrewBurndown.vue?vue&type=template&id=d4086914&scoped=true&"
import script from "./CrewBurndown.vue?vue&type=script&lang=ts&"
export * from "./CrewBurndown.vue?vue&type=script&lang=ts&"
import style0 from "./CrewBurndown.vue?vue&type=style&index=0&id=d4086914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4086914",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
